import { fetchTermsAndConditionsLogic } from './fetchTermsAndConditionsLogic';

export const logic = [fetchTermsAndConditionsLogic];
